import { ApiService, CaseAdmin } from "pwapi";

import { AsyncSagaAction, createAsyncSaga } from "shared/utils/asyncActions";

import {
  FETCH_LIS_CASE_REQUEST,
  FETCH_LIS_CASE_SUCCESS,
  FETCH_LIS_CASE_FAILURE,
  UPDATE_LIS_CASE_REQUEST,
  UPDATE_LIS_CASE_SUCCESS,
  UPDATE_LIS_CASE_FAILURE,
  UPLOAD_LIS_DOCUMENT_REQUEST,
  UPLOAD_LIS_DOCUMENT_SUCCESS,
  UPLOAD_LIS_DOCUMENT_FAILURE,
} from "../constants";

type fetchCaseArgs = Parameters<typeof ApiService.retrieveAdminCase>[0];
type updateCaseArgs = Parameters<typeof ApiService.partialUpdateAdminCase>[0];
type uploadDocumentArgs = Parameters<
  typeof ApiService.uploadAdminCaseDocument
>[0];

export const fetchCase: AsyncSagaAction<fetchCaseArgs> = createAsyncSaga(
  FETCH_LIS_CASE_REQUEST,
  FETCH_LIS_CASE_SUCCESS,
  FETCH_LIS_CASE_FAILURE,
  ({ id }: fetchCaseArgs) => `admin/cases/${id}`,
  ({ id }: fetchCaseArgs) =>
    ApiService.retrieveAdminCase({
      id,
    })
);

export const updateCase: AsyncSagaAction<updateCaseArgs> = createAsyncSaga(
  UPDATE_LIS_CASE_REQUEST,
  UPDATE_LIS_CASE_SUCCESS,
  UPDATE_LIS_CASE_FAILURE,
  ({ id }: updateCaseArgs) => `admin/cases/${id}/update`,
  (newValues: updateCaseArgs) =>
    ApiService.partialUpdateAdminCase({
      id: newValues.id,
      requestBody: newValues as CaseAdmin,
    })
);

export const uploadDocument: AsyncSagaAction<any> = createAsyncSaga(
  UPLOAD_LIS_DOCUMENT_REQUEST,
  UPLOAD_LIS_DOCUMENT_SUCCESS,
  UPLOAD_LIS_DOCUMENT_FAILURE,
  () => `admin/documents/upload`,
  (document: uploadDocumentArgs) => ApiService.uploadAdminCaseDocument(document)
);

export const openDocument = async (id: number) => {
  try {
    const response = await ApiService.retrieveAdminCaseDocument({ id: id });
    if (response.presigned_url) {
      window.open(response.presigned_url, "_blank");
    } else {
      console.error("Missing Document");
    }
  } catch (e) {
    console.error("Could not open document");
  }
};
